import React from 'react';



export default function ChapterOpener(props) {
    // React.useEffect(() => {
    //     props.onComplete()
    // }, []);
    props.onComplete()
    return null
}
